// PROP-TNT-REL-CHK
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult } from '../rules';
import IsLoanCategoryEqualTo from '../rules/IsLoanCategoryEqualTo';
import { LoanCategory } from '../../../../../../../../../../types/api';

class SystemPropertyHasRelatedTenantsRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isExpressPlusOrCoreOrIndustryPGPropCo =
      IsLoanCategoryEqualTo.setCategory(
        LoanCategory.EXPRESS_PLUS_PROPCO
      ).evaluate(data) ||
      IsLoanCategoryEqualTo.setCategory(LoanCategory.CORE_PROPCO).evaluate(
        data
      ) ||
      IsLoanCategoryEqualTo.setCategory(
        LoanCategory.INDUSTRY_PG_PROPCO
      ).evaluate(data);

    return isExpressPlusOrCoreOrIndustryPGPropCo
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new SystemPropertyHasRelatedTenantsRuleset();
